 <template>
     <div>
        <h4 class="p-2">Alumnos y accesos</h4>
        <vs-row class="mt-4">
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <template v-if="instituciones.length" autocomplete="off">
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                    <label for="grupo" class="labelInput">
                        Grupo <i class="fas fa-shield-alt"></i>
                    </label>
                    <div style="position: relative">
                        <vs-select
                            filter
                            :loading="loadingGrupo"
                            class="pt-0"
                            id="grupo"
                            placeholder="Seleccionar grupo"
                            :key="grupoId"
                            v-model="grupo"
                            :disabled="!grupos.length">
                            <vs-option v-for="option in grupos" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                            <template #message-danger v-if="errorFields.includes('grupo')">
                                Requerido
                            </template>
                        </vs-select>
                    </div>
            </vs-col>
            <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                <vs-button
                    @click="getAccesoPersonas()"
                >
                    <i class="fas fa-search mr-2"></i>Buscar
                </vs-button>
            </vs-col>
        </vs-row>
        <tabla-personas :cards="cards" :users="users" :grupo="grupo" :institucion="institucion"></tabla-personas>
     </div>
</template>

 <script>
import reportes from '../../../../api/requests/reportes.js'
import TablaPersonas from './tabla-personas.vue'
export default {
    data(){
        return{
            institucion:'',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            grupo: '',
            grupos: [],
            grupoId: (new Date()).getTime(),
            loadingGrupo: false,
            errorFields: [],
            users: [],
            cards: [],
            page: 1
        }
    },
    components:{
        TablaPersonas
    },
    created(){
        this.getInstituciones()
    },
    methods:{
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await reportes.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstituto = false
            }
            catch{

            }
        },
        async getGrupo() {
            if(this.institucion){
                this.loadingGrupo = true
                const params = {
                    ciclo_escolar_id: this.cicloEscolar
                }
                const { data: response } = await reportes.getGrupo(this.institucion, params)
                this.grupos = response
                this.grupoId = (new Date()).getTime()
                this.loadingGrupo = false
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.grupo){
                this.errorFields.push('grupo')
            }
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.errorFields.length){
                const params = {
                    headers: ['fullName', 'matricula', 'ciclo_escolar', 'accesos_totales', 'accesaron', 'grupos'],
                    institucion_id: this.institucion,
                    grupo_id: this.cicloEscolar,
                    page: this. page,
                }

                if(this.grupo[0] == ''){
                    const eliminarGrupo = this.grupo.shift()
                    params.grupo_id = this.grupo
                }else{
                    params.grupo_id = this.grupo
                }

                return params
            } else {
                return null
            }
        },
        async getAccesoPersonas(){
            const params = this.sanityForm()
            if(params){
                const loading = this.$vs.loading()
                try {
                    const { data: response } = await reportes.getAccesoPersonas(params)
                    this.users = response.data
                    console.log(this.users)
                    this.cards = response.st
                    loading.close()
                }
                catch(error){
                    loading.close()
                    console.log(error)
                }
            }
        },
    },
    watch:{
        institucion(){
            this.getGrupo()
        }
    }
}
</script>